module.exports = __webpack_public_path__ + "assets/img/5_1358.b0daaaf7.jpg";